import React, { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { OVERRIDE_METER_STATE_MUTATION } from "../../graphql/mutations/overrideMeterState";
import { useMutation } from "@apollo/client";
import Button from "../Button/Button";
import { METER_TELEMETRY_STATE_VALUES } from "../../utils/meter-telemetry-states";
import { toastFunction, errorToastFunction } from "../../utils/toast";

const ManualOverrideModal = ({ onClose, selectedData, onApply }) => {
  const { handleSubmit, control, setValue } = useForm({
    defaultValues: {
      manualOverride: selectedData.state || "",
    },
  });

  const [currentData, setCurrentData] = useState({});

  useEffect(() => {
    setCurrentData(selectedData);
    setValue("manualOverride", selectedData.state);
  }, [selectedData, setValue]);

  const [overrideMeterState, { loading }] = useMutation(
    OVERRIDE_METER_STATE_MUTATION
  );

  const handleFormSubmit = async (data) => {
    try {
      const response = await overrideMeterState({
        variables: {
          overrideMeterData: {
            latest_meter_telemetry_id: parseInt(currentData.id, 10),
            state: parseInt(data.manualOverride, 10),
          },
        },
      });
      const { success, error } = response.data.overrideMeterState;

      if (success) {
        toastFunction(
          "Meter override applied.",
          "success",
          "meter-override-success"
        );
        onApply();
        return;
      }

      // The override never reached the meter, so leave the modal open for a retry
      console.error(error);
      errorToastFunction(
        { message: error || "Failed to override the meter. Please try again." },
        "meter-override-error"
      );
    } catch (err) {
      console.error(err);
      errorToastFunction(
        {
          message:
            err?.graphQLErrors?.[0]?.message ||
            "Failed to override the meter. Please try again.",
        },
        "meter-override-error"
      );
    }
  };

  return (
    <div className="basic-modal">
      <div className="basic-modal__header">
        <h3>Manual Override</h3>
      </div>
      <div className="basic-modal__body">
        <form onSubmit={handleSubmit(handleFormSubmit)}>
          <div className="radio-group">
            <Controller
              name="manualOverride"
              control={control}
              render={({ field }) => (
                <div className="radio-group__container radio-group__container--vertical">
                  <label className="radio-group__label">
                    <input
                      type="radio"
                      value={METER_TELEMETRY_STATE_VALUES.A_2}
                      {...field}
                      onChange={() =>
                        field.onChange(METER_TELEMETRY_STATE_VALUES.A_2)
                      }
                    />
                    <span>Override ON</span>
                  </label>
                  <label className="radio-group__label">
                    <input
                      type="radio"
                      value={METER_TELEMETRY_STATE_VALUES._3}
                      {...field}
                      onChange={() =>
                        field.onChange(METER_TELEMETRY_STATE_VALUES._3)
                      }
                    />
                    <span>Override OFF</span>
                  </label>
                  <label className="radio-group__label">
                    <input
                      type="radio"
                      value={METER_TELEMETRY_STATE_VALUES.A_0}
                      {...field}
                      onChange={() =>
                        field.onChange(METER_TELEMETRY_STATE_VALUES.A_0)
                      }
                    />
                    <span>Override Disabled</span>
                  </label>
                </div>
              )}
            />
          </div>
          <div className="basic-modal__footer">
            <Button
              type="button"
              onClick={onClose}
              className="button--secondary"
              name="Cancel"
              disabled={loading}
            />
            <Button
              type="submit"
              className="button--primary"
              name={loading ? "Applying..." : "Apply"}
              loading={loading}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default ManualOverrideModal;
